import {Component, OnInit} from '@angular/core';
import {FormApiService} from '@app/core/services/form-api.service';
import {
  MeteringPointCalculationParameterDto,
  MeteringPointCalculationStructureDto,
  MeteringPointCalculationStructureService
} from '@app/api/dmc';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {InputGroupComponent} from '@shared/components/input/input-group/input-group.component';
import {LabelDirective} from '@shared/components/input/label/label.directive';
import {TranslatePipe} from '@ngx-translate/core';
import {InputDirective} from '@shared/components/input/input/input.directive';
import {LucideAngularModule} from 'lucide-angular';
import {CalculationFormComponent} from '@views/calculation/calculation-form/calculation-form.component';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-create-calculation-modal',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    TranslatePipe,
    InputDirective,
    FormsModule,
    LucideAngularModule,
    CalculationFormComponent
  ],
  templateUrl: './create-calculation-modal.component.html',
  styleUrl: './create-calculation-modal.component.css'
})
export class CreateCalculationModalComponent implements OnInit, HasUnsavedChanges {
  /** Form **/
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    meteringPointIdentification: new FormControl(null, [Validators.required]),
    validFrom: new FormControl(null, [Validators.required]),
    calculationStructureInternalName: new FormControl(null, [Validators.required]),
    calculationStructureIsDynamic: new FormControl(),
    parameters: new FormControl(),
  });

  /** ID **/
  public id!: string;

  /** Calculation ID **/
  public calculationId?: string;

  /** Row Handler **/
  public rowHandler: MeteringPointCalculationParameterDto[] = [];

  public algorithmDynamic: boolean = false;

  constructor(
    private readonly formApiService: FormApiService,
    private readonly meteringPointCalculationService: MeteringPointCalculationStructureService,
  ) {
  }

  public ngOnInit(): void {
    if (this.calculationId) {
      this.meteringPointCalculationService.meteringPointCalculationStructureGetPost(this.calculationId).subscribe((data: MeteringPointCalculationStructureDto) => {

        const date = data.validFrom ? data.validFrom.split('T')[0] : null;
        this.form.get('validFrom')?.setValue(date);
        this.form.get('calculationStructureInternalName')?.setValue(data.calculationStructureInternalName ?? null);

        if (data.parameters && data.parameters.length > 0) {
          this.rowHandler = data.parameters;
        }
      });
    }
  }

  public submit(): void {
    this.form.get('meteringPointIdentification')?.setValue(this.id);

    this.formApiService.submit(
      this.form,
      (data) => this.meteringPointCalculationService.meteringPointCalculationStructureAddPost(data),
      {
        preprocess: (data) => ({
          ...data,
          calculationStructureIsDynamic: this.algorithmDynamic,
          parameters: this.rowHandler
        }),
        closeModal: true,
        successMessage: 'meteringpoint.calculation.create.success'
      }
    )
  }

  public edit(): void {
    this.form.get('meteringPointIdentification')?.setValue(this.id);

    this.formApiService.submit(
      this.form,
      (data) => this.meteringPointCalculationService.meteringPointCalculationStructureAddHtxPost(data),
      {
        preprocess: (data) => ({
          ...data,
          calculationStructureIsDynamic: this.algorithmDynamic,
          parameters: this.rowHandler,
          id: this.calculationId,
        }),
        closeModal: true,
        successMessage: 'meteringpoint.calculation.create.success'
      }
    )
  }
}
